import ShareVacancyModal from './ShareVacancyModal.component';

export default ShareVacancyModal;